// extracted by mini-css-extract-plugin
module.exports = {"container":"_2K5pLDy4ZpIU191IVX-kv5"};